import { useContext } from "react";
import { storesContext } from "../store";

const useStores = () => useContext(storesContext);

export default useStores;
